import { render, staticRenderFns } from "./shop-lists.vue?vue&type=template&id=258b53ed&"
import script from "./shop-lists.vue?vue&type=script&lang=js&"
export * from "./shop-lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports